module.exports = __webpack_public_path__ + "img/logo-afilio-transp.0ba6871d.png";